import React from 'react';
import { updatedata } from "../../util/global";
import { customer } from './Datatype';

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  formdata: customer;
  setformdata: (data: customer) => void;
  fetchdata: () => void;
}

// CustomerForm: add/edit modal for a single customer.
// Rendered only while showmodal === "showcustomerform"; the parent owns
// formdata and passes the setter down so every input writes straight into it.
const CustomerForm: React.FC<props> = ({
  showmodal,
  setshowmodal,
  formdata,
  setformdata,
  fetchdata
}) => {
  if (showmodal !== "showcustomerform") return null;

  // save the customer as an appuser with usertype "customer", generate a
  // CUST-xxxxx code on first save, then close the modal and refresh the list.
  // the api hashes password when it is non-empty and leaves it alone otherwise.
  const handlesave = async () => {
    const code = formdata.code || "CUST-" + Date.now().toString().slice(-5);
    const payload = {
      data: {
        ...formdata,
        code,
        datatype: "appuser",
        usertype: "customer"
      }
    };
    await updatedata(payload);
    setshowmodal("");
    fetchdata();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "edit customer" : "add customer"}</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>full name</label>
            <input
              type="text"
              className="form-input"
              value={formdata.name || ''}
              onChange={(e) => setformdata({ ...formdata, name: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>email address</label>
            <input
              type="email"
              className="form-input"
              value={formdata.email || ''}
              onChange={(e) => setformdata({ ...formdata, email: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>mobile phone</label>
            <input
              type="text"
              className="form-input"
              value={formdata.phone || ''}
              onChange={(e) => setformdata({ ...formdata, phone: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>pin code</label>
            <input
              type="text"
              className="form-input"
              value={formdata.pin || ''}
              onChange={(e) => setformdata({ ...formdata, pin: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>address</label>
            <textarea
              className="form-input"
              value={formdata.address || ''}
              onChange={(e) => setformdata({ ...formdata, address: e.target.value })}
            />
          </div>

          <button className="btn-blue full-width" onClick={handlesave}>
            save customer
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerForm;
